<template>
  <div class="pnlMenu">
    <div :class="[nowTab == 'SuperAdminSetting' ? 'pnlMenuSelect' : 'pnlMenuUnSelect']" @click="BackAdminSetting">
      <img class="imgIcon" src="@/assets/img/backend/icon_lock_Hover.png" />
      <label class="lblMenu">{{ $t('Menu.AdminSetting') }}</label>
    </div>
    <div :class="[nowTab == 'SuperAdminSRCLang' ? 'pnlMenuSelect' : 'pnlMenuUnSelect']" @click="BackSCRLang">
      <img class="imgIcon" src="@/assets/img/menu/icon_translation_hover.png" />
      <label class="lblMenu">{{ $t('Menu.SCRLang') }}</label>
    </div>

    <div :class="[nowApp == 'Analytic' ? 'pnlMenuBoxSelect' : 'pnlMenuBoxUnSelect']" @click.self="BackAnalyticLecture">
      <img class="imgIcon" src="@/assets/img/menu/icon_data_hover.png" @click.self="BackAnalyticLecture" />
      <label class="lblMenu" @click.self="BackAnalyticLecture">{{ $t('Menu.Analytic') }}</label>
      <img class="imgHint" src="@/assets/img/menu/icon_menu_arrow.png" @click.self="BackAnalyticLecture" />
      <br />

      <div class="pnlSubMenu">
        <div
          :class="[nowTab == 'SuperAdminALecture' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']"
          @click="BackAnalyticLecture"
        >
          <img class="imgSubMenu" src="@/assets/img/menu/icon_Courses_hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.AnalyticLecture') }}</label>
        </div>
        <div
          :class="[nowTab == 'SuperAdminAMachine' ? 'pnlSubMenuSelect' : 'pnlSubMenuUnSelect']"
          @click="BackAnalyticMachine"
        >
          <img class="imgSubMenu" src="@/assets/img/menu/icon_VR_S_hover.png" />
          <label class="lblSubMenu">{{ $t('Menu.AnalyticMachine') }}</label>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      nowTab: '',
      nowApp: '',
    };
  },
  mounted() {
    this.nowTab = this.GetRouteName();
    this.nowApp = this.GetRouteAppName();
  },
  methods: {
    GetRouteName() {
      //return this.$router.currentRoute.name.toLowerCase();
      return this.$router.currentRoute.name;
    },
    GetRouteAppName() {
      var path = this.$route.fullPath;
      if (path.includes('Analytic')) {
        return 'Analytic';
      } else {
        return '';
      }
    },
    BackAdminSetting() {
      if (this.nowTab != 'SuperAdminSetting') {
        this.$router.push({ path: '/SuperAdmin/AdminSetting' });
        this.nowTab = 'SuperAdminSetting';
      }
    },
    BackSCRLang() {
      if (this.nowTab != 'SuperAdminSRCLang') {
        this.$router.push({ path: '/SuperAdmin/SCRLang' });
        this.nowTab = 'SuperAdminSRCLang';
      }
    },
    BackAnalyticLecture() {
      if (this.nowTab != 'SuperAdminALecture') {
        this.$router.push({ path: '/SuperAdmin/AnalyticLecture' });
        this.nowTab = 'SuperAdminALecture';
      }
    },
    BackAnalyticMachine() {
      if (this.nowTab != 'SuperAdminAMachine') {
        this.$router.push({ path: '/SuperAdmin/AnalyticMachine' });
        this.nowTab = 'SuperAdminAMachine';
      }
    },
  },
};
</script>